export function normalizeDateOnlyInput(value: unknown): string {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }

  const normalized = String(value || '').trim();
  const isoPrefixMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})/);
  return isoPrefixMatch?.[1] || '';
}

export function parseDateOnlyToTime(value: unknown): number | null {
  const normalized = normalizeDateOnlyInput(value);
  if (!normalized) {
    return null;
  }
  const parsed = new Date(`${normalized}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed.getTime();
}

export function isDateWithinRange(value: unknown, fromDate: unknown, toDate: unknown): boolean {
  const candidate = parseDateOnlyToTime(value);
  if (candidate === null) {
    return false;
  }

  const from = parseDateOnlyToTime(fromDate);
  const to = parseDateOnlyToTime(toDate);
  if (from !== null && candidate < from) {
    return false;
  }
  if (to !== null && candidate > to) {
    return false;
  }
  return true;
}

export function hasDateRange(fromDate: unknown, toDate: unknown): boolean {
  return Boolean(normalizeDateOnlyInput(fromDate) || normalizeDateOnlyInput(toDate));
}
